import { getToken, getUser } from "../commons";
import { postAPICall } from "./axiosCommons";
import { removeUserSession } from "../commons";

export const loginUser = async (username, password, areaCode) => {
  try {
    const response = await postAPICall(process.env.REACT_APP_LINK + "logins", {
      username: username,
      password: password,
      user_type: "Admin",
      // area_code: areaCode,
    });
    let userData = response?.data?.data;
    if (userData) {
    localStorage.setItem("user", userData.id);
    localStorage.setItem("id", userData.id);
    localStorage.setItem("name", userData.username);
    localStorage.setItem("role", userData.role);
    localStorage.setItem("type", userData.type);
    localStorage.setItem("token", userData.token);
    localStorage.setItem("first_name", JSON.stringify(userData.first_name));
    localStorage.setItem("last_name", JSON.stringify(userData.last_name));
    localStorage.setItem("username", JSON.stringify(userData.username));
}
    return { data: response };
  } catch (error) {
    return { error: error.response };
  }
};

export const logoutUser = async () => {
  try {
    const response = await postAPICall(process.env.REACT_APP_LINK + "logouts", {
      requester: getUser(),
      token: getToken(),
      login_id: getUser(),
    });
    removeUserSession();
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};
